import React from 'react';

export const highlightText = (text: string, highlight: string): React.ReactNode => {
  if (!highlight.trim()) return text;

  const regex = new RegExp(`(${highlight})`, 'gi');
  const segments: string[] = text.split(regex);

  return segments.map((segment) => (regex.test(segment) ? (
    <span
      className="highlight"
    >
      {segment}
    </span>
  ) : (
    segment
  )));
};

export function getParam(
  params: URLSearchParams,
  name: string
): string {
  const value = params.get(name);

  if (value === null) {
    throw new Error(`Missing URL param: ${name}`);
  }

  return value;
}
